import $ from 'jquery';
import Swup from 'swup';
import 'jquery.easing';
// import Flickity from 'flickity';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;


Alpine.plugin(intersect)

function l(m) { 
  console.log(m); 
};

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

const $d = $(document), $w = $(window);

function playVideo() {
  
  let el;
  if($(this).prop('localName') == 'h3') {
    el = $(this).parent().next();
  } else {
    el = $(this);
  }

  if (el.find('.thumb_video video').length) {
    l('- playVideo');
    let src = el.find('source').data('src');
    el.find('video').attr('src', src);
    el.addClass('playing').find('.thumb_video video').get(0).play();
  }

  console.log(this)
}

function pauseVideo() {
  
  let el;
  if($(this).prop('localName') == 'h3') {
    el = $(this).parent().next();
  } else {
    el = $(this);
  }

  if (el.find('.thumb_video video').length) {
    l('- pauseVideo');
    el.removeClass('playing').find('.thumb_video video').get(0).pause();
  }
}

function updateNav() {
  let page = window.location.pathname.split('/')[1];
  l('- updateNav:' + page);
  // reset nav items
  $('.header_navitem a').removeClass('active')
  
  if(page == '') {
    $('.header_navitem:first-child a').addClass('active');
  } else {
    $('a[href*=' + page + ']').addClass('active');
  }
}

function updateBody() {
  // let pageClass = html.match(/<body class="(.*?)">/)[1].trim();
  let page = window.location.pathname.split('/')[1];
  if(page == '') {
    page = ''
  } else {
    page = page;
  }
  $('body').removeClass().addClass(page);
}

function scrollTop() {
  l('- scrolTop');
  $('html, body').animate({
    'scrollTop' : 0
  }, 500, 'easeInOutQuint');
}

function scrollTopInstant() {
  l('- scrolTopInstant');
  $('html, body').animate({
    'scrollTop' : 0
  }, 0);
}

function scrollTarget(e) {
  e.preventDefault();
  let target = $(this).attr('href'),
      top =  $(target).offset().top;
  
  $('html, body').animate({
    'scrollTop' : top
  }, 500, 'easeInOutQuint');
}

function showOverlay(e) {
  console.log('showOverlay');
  e.preventDefault();
  $('.work_info').addClass('active');
}
function closeOverlay(e) {
  console.log('closeOverlay');
  e.preventDefault();
  $('.work_info').removeClass('active');
}



function lazyImages(){
  l('lazyImages');
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          // l(lazyImage);
          // lazyImage.srcset = lazyImage.dataset.srcset;
          $(lazyImage).parent().parent().parent().removeClass('out');
          // lazyImage.classList.add("animate");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    }, { rootMargin: "0px 0px -15% 0px" });

    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
}

function changeBg() {
  let color = $(this).parent().parent().data('color');
  l('- changeBg: ' + color);
  $('body').css({
    'background-color': color
  });
  $('.work_headernav').css({
    'background-color': color
  })
  $('#cursor').css({
    'background-color': color
  });
}


function resetBg() {
  l('- resetBg');
  $('body').css({
    'background-color': ''
  });
  $('.work_headernav').css({
    'background-color': ''
  });
  $('#cursor').css({
    'background-color': ''
  });
}

function loadInElements() {
  // $('.header_logo').removeClass('out');
  $('.header .out').each(function(index){
    let delay = index * 200,
      that = $(this);
    setTimeout(function(){
      that.removeClass('out');
    }, delay);
    
  })
  $('.header_logo').removeClass('out');
  $('.work_filter').removeClass('out');
}

function resetNav() {
  $('.header').removeClass('offscreen');
}

function init() {
  l('init')
  // Run initially then on every pageload
  
  resetNav();
  updateNav();
  updateBody();
  // scrollTop();

  // Mobile: Play videos on screen
  if (window.mobileCheck()) {
    console.log('mobile intersection');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const intersecting = entry.isIntersecting
        // entry.target.style.opacity = intersecting ? ".1" : "1";
        let el = $(entry.target);
        if(intersecting) {

          // play
          let src = el.find('source').data('src')
          el.find('video').attr('src', src);
          el.addClass('playing').find('.thumb_video video').get(0).play();
          console.log('play')
          console.log(el);


        } else {
          // pause
          el.removeClass('playing').find('.thumb_video video').get(0).pause();
          console.log('pause')
          console.log(el);
        }
      })
    })
    let thumbs = document.querySelectorAll(".thumb_image");
    thumbs.forEach(single => {
      observer.observe(single)
    })
  }
  

  if(document.querySelector('.infoslider')) {
    var elem = document.querySelector('.infoslider');
    var flckty = new Flickity( elem, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      imagesLoaded: true
    });
    flckty.on( 'change', function( index ) {
      // l(index + 1);
      let current = index + 1,
          total = $('.infoslider_counter').text().split('/')[1],
          newCount = current + '/' + total;
      $('.infoslider_counter').empty().text(newCount);
    });
  
  }

  if(document.querySelector('.flckty')) {
    var elem = document.querySelector('.flckty');
    var flckty = new Flickity( elem, {
      // cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false
      // fade: true
    });
    flckty.on( 'change', function( index ) {
      // l(index + 1);
      let current = index + 1,
          total = $('.work_count').text().split('/')[1],
          newCount = current + '/' + total;
      $('.work_count').empty().text(newCount);
    });
    
    $('.work_next-video').on('click', function(){
      flckty.next(true, false);
    });

    $('.work_prev-video').on('click', function(){
      flckty.previous(true, false);
    });

    $('.work_mobile-next-video').on('click', function(){
      flckty.next(true, false);
    });

    $('.work_mobile-prev-video').on('click', function(){
      flckty.previous(true, false);
    });

    $('.work_count').on('click', function(){
      l('next slide');
      
      flckty.next(true, false);
      let current = flckty.selectedIndex + 1,
          total = $('.work_count').text().split('/')[1],
          newCount = current + '/' + total;
      $('.work_count').empty().text(newCount);
    });
  }


  // if lazy images do lazyloading
  if (document.querySelector('img.lazy')) {
      lazyImages();
  }
  
  // if its a project just straight to the top
  if(document.querySelector('.work_info')) {
    scrollTopInstant();
  }

  // if url contains hash run the projects filter
  if(window.location.hash) {
    filterProjects();
  }

  if($('.work_filter.out') || $('.header .out')) {
    l('loadin');
    loadInElements();
  }

  if($('.work_headernav')) {
    setTimeout(function(){
      showNavBg();
    }, 500);
  }

  if($('.info_container')) {
    scrollTop();
  }

  if(window.location.pathname == '/info') {
    initPayPalButton();
  }

}

function showNavBg() {
  $('.work_headernav').addClass('active');
}

function updateCursor(event){
  // l('x:' + event.clientX + ' y: ' + event.clientY);
  $('#cursor').css({
    'transform': 'translate('+ (event.clientX - 10) +'px , ' + (event.clientY - 10) + 'px)'
  });
}

function filterProjects(event) {
  // reset filter active 
  $('.work_filter a').removeClass('active');
  
  // determine if click or url filter
  let cat;  
  if(event !== undefined) {
    // set the cat = clicked link
    event.preventDefault();
    cat = $(this).attr('href').split('/work#')[1];
    // highlight clicked filter button
    $(this).addClass('active');
  } else {
    // set the cat = url hash
    cat = window.location.hash.split('#')[1];
    // find filter to highlught based on hash
    $('.work_filter a[href*=' + cat + ']').addClass('active');
  }

  // update the hash
  window.location.hash = '#' + cat;

  // if is 'all' 
  if(cat === 'all') {
    $('.thumb').removeClass('remove');
  // or single cat
  } else {
    $('.thumb').addClass('remove');
    $('.thumb[data-tags*="' + cat + '"]').removeClass('remove');
  }
}

function headerBg() {
  l('- headerBg');
  $('.work_headernav').removeClass('active');
}

function leftArrowOn(){
  $('#cursor').addClass('left')
}

function leftArrowOff(){
  $('#cursor').removeClass('left')
}

function rightArrowOn(){
  $('#cursor').addClass('right')
}

function rightArrowOff(){
  $('#cursor').removeClass('right')
}

function showShare() {
  $('.work_share').addClass('show');
}
function hideShare() {
  $('.work_share').removeClass('show');
}

function triggerMobileMenu() {
  if($('.flyout').hasClass('active')) {
    $('.header').removeClass('trans');
    $('body').removeClass('locked');
    $('.header_mobile-menu-button a').removeClass('active');
    $('.header_logo').removeClass('active');
    $('.header_mobile-menu-button a span').empty().text('Menu');
    $('.flyout').removeClass('active');
  } else {
    $('.header').addClass('trans');
    $('body').addClass('locked');
    $('.header_mobile-menu-button a').addClass('active');
    $('.header_logo').addClass('active');
    $('.header_mobile-menu-button a span').empty().text('Close');
    $('.flyout').addClass('active');
  }
}

function triggerCredits() {
  if($('.work_credits').hasClass('show')) {
    $('.work_credits').removeClass('show');
  } else {
    $('.work_credits').addClass('show');
  }
}

function showPaypal() {
  l('paypal');
  $('body').addClass('locked');
  $('.modal_paypal').addClass('active');

}

function hidePaypal() {
  l('paypal');
  $('body').removeClass('locked');
  $('.modal_paypal').removeClass('active');
}

const swup = new Swup();

// run once 
init();

// this event runs for every page view after initial load
swup.on('contentReplaced', init);

// // Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();

// Events
$d
  .on('mouseenter', '.thumb_image, .thumb_text h3', playVideo)
  .on('mouseleave', '.thumb_image, .thumb_text h3', pauseVideo)
  .on('click', '.top', scrollTop)
  .on('click', '.scrolltodescription', scrollTarget)
  .on('click', '.showoverlay', showOverlay)
  .on('click', '.closeoverlay', closeOverlay)
  .on('mouseenter', '.thumb[data-color] .thumb_image', changeBg)
  .on('mouseleave', '.thumb .thumb_image', resetBg)
  .on('click', '.work_filter a', filterProjects)
  .on('mousemove', updateCursor)
  .on('click', '.thumb a', resetBg)
  .on('click', '.work_pagination a', headerBg)
  .on('mouseenter', '.work_prev-video', leftArrowOn)
  .on('mouseleave', '.work_prev-video', leftArrowOff)
  .on('mouseenter', '.work_next-video', rightArrowOn)
  .on('mouseleave', '.work_next-video', rightArrowOff)
  .on('click', '.work_share', showShare)
  .on('click', '.work_videowrap', hideShare)
  .on('click', '.header_mobile-menu-button a', triggerMobileMenu)
  .on('click', '.flyout_link', triggerMobileMenu)
  .on('click', '.info_paypal', showPaypal)
  .on('click', '.modal_close', hidePaypal)
  .on('click', '.work_credits h3', triggerCredits);



  function initPayPalButton() {
    l('initPaypalButton');
    var description = document.querySelector('#smart-button-container #description');
    var amount = document.querySelector('#smart-button-container #amount');
    var descriptionError = document.querySelector('#smart-button-container #descriptionError');
    var priceError = document.querySelector('#smart-button-container #priceLabelError');
    var invoiceid = document.querySelector('#smart-button-container #invoiceid');
    var invoiceidError = document.querySelector('#smart-button-container #invoiceidError');
    var invoiceidDiv = document.querySelector('#smart-button-container #invoiceidDiv');

    var elArr = [description, amount];

    if (invoiceidDiv.firstChild.innerHTML.length > 1) {
      invoiceidDiv.style.display = "block";
    }

    var purchase_units = [];
    purchase_units[0] = {};
    purchase_units[0].amount = {};

    function validate(event) {
      return event.value.length > 0;
    }

    paypal.Buttons({
      style: {
        color: 'black',
        shape: 'rect',
        label: 'pay',
        layout: 'vertical',
        
      },

      onInit: function (data, actions) {
        actions.disable();

        if(invoiceidDiv.style.display === "block") {
          elArr.push(invoiceid);
        }

        elArr.forEach(function (item) {
          item.addEventListener('keyup', function (event) {
            var result = elArr.every(validate);
            if (result) {
              actions.enable();
            } else {
              actions.disable();
            }
          });
        });
      },

      onClick: function () {
        if (description.value.length < 1) {
          descriptionError.style.display = "block";
        } else {
          descriptionError.style.display = "none";
        }

        if (amount.value.length < 1) {
          priceError.style.visibility = "visible";
        } else {
          priceError.style.visibility = "hidden";
        }

        if (invoiceid.value.length < 1 && invoiceidDiv.style.display === "block") {
          invoiceidError.style.visibility = "visible";
        } else {
          invoiceidError.style.visibility = "hidden";
        }

        purchase_units[0].description = description.value;
        purchase_units[0].amount.value = amount.value;

        if(invoiceid.value !== '') {
          purchase_units[0].invoice_id = invoiceid.value;
        }
      },

      createOrder: function (data, actions) {
        return actions.order.create({
          purchase_units: purchase_units,
        });
      },

      onApprove: function (data, actions) {
        return actions.order.capture().then(function (details) {
          alert('Transaction completed by ' + details.payer.name.given_name + '!');
        });
      },

      onError: function (err) {
        console.log(err);
      }
    }).render('#paypal-button-container');
  }